import React from 'react';
import {connect} from 'react-redux';
import {FaArrowLeft} from 'react-icons/lib/fa';

class IndexDetails extends React.Component {

    redirect = () => {
        this.props.history.goBack();
    }

    render() {
        return (
            <div className="index-page">
                <br/>
                <span onClick={this.redirect} title='back' className='nwmCol backArr'>
              <FaArrowLeft/>
            </span>
                <div className="container page container_t">
                    <div className='col-md-12'>
                        <p className="head">
                            Overview
                        </p>
                        The RFR Index is a daily realised compounded rate starting with a base value:
                        <br/>
                        <br/>
                        <b>SONIA</b>: base of ‘100’ on 23 April 2018, the date the Bank of England launched
                           <a href='https://www.bankofengland.co.uk/markets/sonia-benchmark/administration-of-sonia#reform'
                           title='https://www.bankofengland.co.uk/markets/sonia-benchmark/administration-of-sonia#reform'
                           style={{"text-decoration" : "none"}}
                           target='_blank'> reformed SONIA</a>.
                        <br/>
                        <br/>
                        <b>SOFR</b>: base of ‘1’ on 02 April 2018
                        <br/>
                        <br/>
                        <b>€STR</b>: base of ‘1’ on 01 October 2019
                        <br/>
                        <br/>
                        <b>TONAR</b>: base of ‘1’ on 04 January 2018
                        <br/>
                        <br/>
                        The index operates like a price index, and may be used to calculate the annualised realised rate
                        between any two dates as set out in example below.
                        <br/>
                        <br/>
                        <p className="heading">
                            Worked Example for SONIA
                        </p>
                        Given the index on two separate dates, it is possible to easily calculate the rate. For example take these two dates:
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                Index [Start]: Tue, 19 Mar 2019 index was: <b>100.56805133</b>
                            </li>
                            <li>
                                Index [End]: Mon, 10 Jun 2019 index was: <b>100.73013371</b>
                            </li>
                        </ul>
                        By applying the formula:
                        <br/>
                        <br/>
                        <div className="marginLeft40">
                            ( Index [End] / Index [Start] ) - 1
                        </div>
                        <br/>
                        you obtain the result <b> 0.001611669</b>
                        <br/>
                        <br/>
                        You can then obtain the annualised compounded rate for the period by applying formula:
                        <br/>
                        <br/>
                        <div className="marginLeft40">
                            Result x ( 365 / ( EndDate - StartDate ) )
                        </div>
                        <br/>
                        Given there are 83 calendar days between start and end this gives <b>0.007087459</b> which when
                        rounded to 4 decimal places as a % gives <b>0.7087%</b>
                        <br/>
                        <br/>
                        <p className="heading">
                            Program Interface (‘API’)
                        </p>
                            {/* <p>It is possible to access the calculation results on our website via a program interface (API).  Please register via the NatWest Markets Developer Portal at 
                                    <a href='https://developer.nwm.io'
                                title='https://developer.nwm.io'
                                style={{"text-decoration" : "none"}}
                                target='_blank'> https://developer.nwm.io</a>.  The interface uses OAUTH2 client credential based security, which our 
                                <a href="mailto:developersupport@natwestmarkets.com" title="developersupport@natwestmarkets.com" target="_blank"> developer team</a> can help explain if you are not familiar with it, or if you have more general questions about the site contact us at <a href="mailto:rfr@natwestmarkets.com" title="rfr@natwestmarkets.com" target="_blank">rfr@natwestmarkets.com</a>.
                            </p> */}
                            <p>It is possible to access the calculation results on our website via a program interface (API).
                                Please contact us at <a href="mailto:rfr@natwestmarkets.com" title="rfr@natwestmarkets.com" target="_blank">rfr@natwestmarkets.com</a> if you would like to hear more about this service.
                            </p>
                    </div>
                    <br/>
                    <br/>
                </div>
            </div>

        );
    }
}

export default IndexDetails;


// WEBPACK FOOTER //
// ./src/components/IndexDetails.js